import { ContentPage } from '@/components/content-page'
import { RegisterForm } from '@/components/register-form'

export default function RegisterPage() {
  return (
    <ContentPage
      eyebrow="// account"
      title="Create your account"
      description="Register with an email and password to get the most out of NewEmail. By registering you gain access to the messaging forums."
    >
      <div className="mx-auto w-full max-w-md">
        <RegisterForm />
        <p className="mt-4 text-center text-sm text-muted-foreground">
          No information you provide will ever be shared or sold. Everything on this site is kept
          private and secure.
        </p>
      </div>
    </ContentPage>
  )
}
